import $ from 'jquery';
window.$ = window.jQuery = $;

( function( $ ) {
	"use strict";

	var TLS_Checkout = function() {

		var self = this;

		this.show_frontent_invoice_data = function(){
			$( '#thwmscf_wrapper .invoice_frontend_data' ).hide();
			if ( $( this ).is( ':checked' ) ) {
				$( '.invoice_frontend_data' ).slideDown();
			}
		};

		// al trigger dell'errore checkout riporto focus su tab fatturazione
		this.checkout_error = function()
		{
			$('#thwmscf-tabs #step-1').trigger('click');
		}

		/**
		 * Event binding.
		 */
		this.bind = function() {
            $( document ).on( 'ready', function () {
                $( '#thwmscf_wrapper .invoice_frontend_data' ).hide();
            } );
                
			$( document ).on( 'change', '#richiedi-fattura-title input', self.show_frontent_invoice_data );
            $( document ).on( 'click', '#richiedi-fattura-title', function(){
				console.log('change fattura', $(this).find('input'));
				var input = $(this).find('input');
        		input.prop("checked", !input.prop("checked"));
				input.trigger('change');
			});

			// trigger checkout error
			$( document ).on( 'checkout_error', self.checkout_error);
		
		};

		/**
		 * Initialization.
		 */
		this.init = function() {
			self.bind();
		};

		this.init();

	};

	( new TLS_Checkout() );

} )( jQuery );